
/**
 * JQUERY: Generic get error message from Response class error.
 * @param {Object} jqXhr JQuery xhr object.
 * @returns {String}
 */
const jqGetAjaxError = function(jqXhr) {
    let error = '';
    if (!jqXhr.responseText) {
        return error;
    }
    try {
        const response = JSON.parse(jqXhr.responseText);
        if (response.error) {
            error = response.error;
        }
    } catch (e) {
        // just avoiding json parse issues
    }
    return error;
};

export {
    jqGetAjaxError
};
